import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const DEDUPE_WINDOW_MS = 1500;
const lastToastAtByKey = new Map();

function shouldSkipToast(type, title) {
  const key = `${type}:${String(title ?? '')}`;
  const now = Date.now();
  const lastAt = lastToastAtByKey.get(key);
  if (typeof lastAt === 'number' && now - lastAt < DEDUPE_WINDOW_MS) {
    return true;
  }
  lastToastAtByKey.set(key, now);
  return false;
}

const AlertServie = {
  init(app) {},
  successMessage(title = 'Success') {
    if (shouldSkipToast('success', title)) return;
    toast.success(title);
  },
  errorMessage(title = 'Error') {
    if (shouldSkipToast('error', title)) return;
    toast.error(title);
  },
  warningMessage(title = 'Warning') {
    if (shouldSkipToast('warning', title)) return;
    toast.warning(title);
  },
  infoMessage(title = 'Info') {
    if (shouldSkipToast('info', title)) return;
    toast.info(title);
  }
};

export default AlertServie;
